import { call, put, all } from "redux-saga/effects";
import { logoutAPI } from "../api/LogoutCall";
import { logoutSuccess, logoutFailed } from "../actions/logoutactions";
import { moveToLoginPage } from "../actions/routeactions";
import { reportError, reportSuccess } from "../actions/erroractions";

export function* logoutSaga() {
  const result = yield call(logoutAPI);

  try {
    if (result === 200) {
      yield all([
        put(logoutSuccess()),
        put(moveToLoginPage()),
        put(reportSuccess("Successfully logged out")),
      ]);
    } else {
      yield all([
        put(logoutFailed()),
        put(reportError("Unable to logout")),
        put(moveToLoginPage()),
      ]);
    }
  } catch (ex) {
    yield all([
      put(logoutFailed()),
      put(reportError("Unable to reach server")),
      put(moveToLoginPage()),
    ]);
  }
}
